import { createTheme, type MantineTheme, Radio } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineRadio: PartialDeep<MantineTheme> = createTheme({
  components: {
    Radio: Radio.extend({
      defaultProps: {
        color: 'purple.5',
      },
    }),
  },
});
